export default __webpack_public_path__ + "static/media/smilyy.81c17060.svg";